// extracted by mini-css-extract-plugin
module.exports = {"analytics":"_22WbWb"};